import { Box } from "@outschool/backpack";
import { ClassDetailsQuery_ActivityFragment } from "@outschool/gql-frontend-generated";
import { SampleClubPostsBanner } from "@outschool/ui-components-shared";
import React from "react";

import { SectionCallToActionProps } from "./AvailableTimes/types";
import HowGroupsWork from "./HowGroupsWork";

interface ClubExplanatonSectionProps {
  activity: ClassDetailsQuery_ActivityFragment;
  isOrganizationEnrollment: boolean;
  SectionCallToAction: React.FC<SectionCallToActionProps>;
}

export default function ClubExplanatonSection({
  activity,
  isOrganizationEnrollment,
  SectionCallToAction,
}: ClubExplanatonSectionProps) {
  const howGroupsWorkRef = React.useRef<HTMLDivElement>(null);
  const scrollToHowGroupsWorkSection = React.useCallback(() => {
    howGroupsWorkRef?.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <SampleClubPostsBanner
        // @ts-ignore TS(2322): Type '{ __typename?: "Activity" | undefined; upsel... Remove this comment to see the full error message
        activity={activity}
        onLearnHowGroupsWorkClick={scrollToHowGroupsWorkSection}
      />
      <Box ref={howGroupsWorkRef}>
        <HowGroupsWork />
        {!activity.wasPublishedInThePast && (
          <Box flex sx={{ justifyContent: "center" }}>
            <SectionCallToAction
              activity={activity}
              section={activity.clubSection}
              isOrganizationEnrollment={isOrganizationEnrollment}
              trackingSharedProperties={{
                component: "ClubExplanatonSection",
              }}
            />
          </Box>
        )}
      </Box>
    </>
  );
}
